module.exports = __webpack_public_path__ + "img/students.acd37c3d.jpg";